// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__oWbE_","membership":"FAQ_membership__u2LBL","contact":"FAQ_contact__c4Oy3","textContent":"FAQ_textContent__JVMqx","faqContent":"FAQ_faqContent__SUXuq"};